/**
 * "Op de kaart" (sessie 73 blok 3): vraag de copiloot van de klant om
 * uit een feit uit een gesprek op de kaart te zetten wat over het dier
 * bekend is. De copiloot luistert zelf naar `copiloot:vraag`.
 */
import type { KaartGespreksfeit } from "../types";

export const OP_DE_KAART_TEKST = "Zet op de kaart wat hieruit over het dier bekend is: ";

export function vraagCopiloot(klantId: string, feit: KaartGespreksfeit): void {
  window.dispatchEvent(
    new CustomEvent("copiloot:vraag", {
      detail: { soort: "klant", id: klantId, tekst: OP_DE_KAART_TEKST + feit.tekst },
    }),
  );
}
